import api from './api';

/** #519 — AI learning path drafts (preview → confirm) and the feature status. */
export interface AiPathStep {
    course_id: number;
    course_title: string;
    difficulty: string;
    estimated_duration: number | null;
    reason: string;
}

export interface AiPathDraft {
    title: string;
    estimated_hours: number;
    steps: AiPathStep[];
}

export interface AiPathStatus { enabled: boolean; canCreateCompanyPath: boolean }

export interface AiPathCreateInput {
    title: string;
    description?: string | null;
    goal?: string | null;
    level?: string | null;
    steps: { course_id: number; reason?: string | null }[];
    certificate_mode?: 'per_course' | 'path';
    personal?: boolean;
}

export interface AiPathCreated { id: number; title: string; slug: string; personal: boolean; isActive: boolean; certificateMode: string; courseCount: number }

export const aiLearningPathService = {
    async status(): Promise<AiPathStatus> {
        const { data } = await api.get<AiPathStatus>('/ai/learning-paths/status');
        return data;
    },
    async preview(topic: string, goal: string, level: string): Promise<AiPathDraft> {
        const { data } = await api.post<AiPathDraft>('/ai/learning-paths/preview', { topic, goal: goal || null, level: level || null });
        return data;
    },
    async create(input: AiPathCreateInput): Promise<AiPathCreated> {
        const { data } = await api.post<AiPathCreated>('/ai/learning-paths', input);
        return data;
    },
};

export default aiLearningPathService;
